import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { useTracker } from '../../../context/hooks';
import { SeoRecommendations } from '../../constants';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const AddTitleKBLink = () => {
  const {
    track
  } = useTracker();
  const handleClickKBLink = event => {
    track('clickedLearnMoreLink', {
      recommendationType: SeoRecommendations.ADD_TITLE,
      linkAddress: event.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsx(Link, {
    href: "https://blog.hubspot.com/blog/tabid/6307/bid/5984/spilling-seo-juice-3-dos-and-don-ts-for-writing-great-page-titles.aspx",
    external: true,
    onClick: handleClickKBLink,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.linkText.ADD_TITLE"
    })
  });
};
export const AddTitleView = ({
  auditResult,
  editorApi
}) => {
  const {
    track
  } = useTracker();
  const handleTrackAction = () => {
    track('clickedFixLink', {
      recommendationType: SeoRecommendations.ADD_TITLE
    });
  };
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    testId: "add-title-rec",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.ADD_TITLE"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_TITLE"
    }),
    status: auditResult.status,
    action: editorApi.addPageTitle,
    actionButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.actions.ADD_TITLE"
    }),
    onTrackAction: handleTrackAction,
    children: /*#__PURE__*/_jsx(View, {
      marginInlineStart: "600",
      marginBlockEnd: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(AddTitleKBLink, {})
    })
  });
};